import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { Button, ButtonBadge, MessageContainer } from './styled';

export interface RequestsMenuButtonProps {
    totalRequests: number;
    isMenuOpen: boolean;
}

const RequestsMenuButton: React.StatelessComponent<RequestsMenuButtonProps> = ({ totalRequests, isMenuOpen }) => {
    return (
        <Button isMenuOpen={isMenuOpen} actionSubjectId="navbarRequests" aria-expanded={isMenuOpen}>
            {totalRequests > 0 && <ButtonBadge>{totalRequests}</ButtonBadge>}
            <MessageContainer>
                <FormattedMessage {...messages.requestsMenuTitle} />
            </MessageContainer>
        </Button>
    );
};

export default RequestsMenuButton;
